import { ConfirmationDialog, useCurrentOrPrevious } from '@dittolive/anvil'
import React from 'react'

import CreateOrUpdateWebhookForm, {
  CREATE_OR_UPDATE_WEBHOOK_FORM_ID,
} from './CreateOrUpdateWebhookForm'

type Props = {
  /** The webhook being edited. Also controls modal visibility. */
  webhook?: {
    name: string
    url: string
    legacy?: boolean
  }
  /** Callback to close the modal. */
  onCancel: () => void
  /** Callback to confirm the edit of the webhook. */
  onConfirm: (
    forProvider: string,
    name: string,
    url: string,
    legacy: boolean,
  ) => void
  /** Current list of other webhooks, to avoid duplicated names being created. */
  existingWebhookNames: string[]
  /** Whether DQL auth webhook feature is enabled (shows legacy toggle) */
  enableDqlAuthWebhook?: boolean
  /** Optional additional content to render below the form */
  children?: React.ReactNode
}

export default function EditProviderModal({
  webhook,
  onCancel,
  onConfirm,
  existingWebhookNames,
  enableDqlAuthWebhook,
  children,
}: Props) {
  const displayedWebhook = useCurrentOrPrevious(webhook)

  const handleSubmit = (name: string, url: string, legacy: boolean) => {
    if (webhook) {
      onConfirm(webhook.name, name, url, legacy)
    }
  }

  return (
    <ConfirmationDialog
      size="md"
      open={!!webhook}
      onCancel={onCancel}
      confirmButtonText="Edit webhook"
      cancelButtonText="Cancel"
      confirmationButtonForm={CREATE_OR_UPDATE_WEBHOOK_FORM_ID}
      data-testid="editWebhookModal"
      title="Edit auth webhook"
      description="Update your webhook name and URL."
    >
      <CreateOrUpdateWebhookForm
        webhook={displayedWebhook}
        existingWebhookNames={existingWebhookNames}
        onSubmit={handleSubmit}
        enableDqlAuthWebhook={enableDqlAuthWebhook}
      />
      {children}
    </ConfirmationDialog>
  )
}
